// Docs: https://mymth.github.io/vanillajs-datepicker/#/

import { Datepicker } from 'vanillajs-datepicker';

const DPicker = {
  el: {
    singles: document.querySelectorAll('.dpicker'),
  },
  init() {
    this.singles()
  },
  singles() {
    if (this.el.singles) {
      Array.prototype.forEach.call(this.el.singles, item => {

        const dp = new Datepicker(item, {
          format: 'dd.mm.yyyy',
          autoHide: true,
        })
      })
    }
  },
}

export default DPicker